
export const tokenToTagsMapping = {
  angular: 'Angular',
  go: 'Go',
  golang: 'GoLang',
  react: 'ReactJS',
  vue: 'VueJS',
  vuejs: 'VueJS',
  'vue.js': 'VueJS',
  ngrx: 'NgRX',
  rxjs: 'RxJS',
  mobx: 'MobX',
  redux: 'Redux',
  javascript: 'JavaScript',
  typescript: 'TypeScript',
  graphql: 'GraphQL',
  nodejs: 'NodeJS',
  'node.js': 'NodeJS',  
  kotlin: 'Kotlin',
  flutter: 'Flutter',
  android: 'AndroidDev',
  api: 'API',
  rest: 'REST',
  js: 'JavaScript',
  ci: 'CI',
  cd: 'CD',
  wasm: 'WASM',
  svelte: 'Svelte',
  rust: 'Rust', 
  docker: 'Docker',
  jamstack: 'JAMStack',
  spa: 'SPA', 
  jest: 'Jest', 
  enzyme: 'Enzyme', 
  seo: 'SEO',
  css: 'CSS',
  html: 'HTML',
  ux: 'UX',
  machinelearning: 'MachineLearning',
  gamedev: 'GameDev',
  aws: 'AWS',
  java: 'Java',
  python: 'Python',
  fontawesome: 'FontAwesome',
  http: 'HTTP',
  https: 'HTTPS',
  crud: 'CRUD',
  ramda: 'RamdaJS',
  mysql: 'MySQL',
  nosql: 'NoSQL',
  github: 'Github',
  gitlab: 'Gitlab',
  nextjs: 'NextJS',
  'next.js': 'NextJS',
  nestjs: 'NestJS',
  'nest.js': 'NestJS',
  nuxtjs: 'NuxtJS',
  'nuxt.js': 'NuxtJS',
  bazel: 'Bazel',
  ivy: 'Ivy',
  gatsby: 'GatsbyJS',
  'gatsby.js': 'GatsbyJS',
  serverless: 'serverless',
  architecture: 'Architecture',
  microservice: 'MicroService',
  microservices: 'MicroServices',
  microfrontend: 'MicroFrontend',
  microfrontends: 'MicroFrontends',

  csharp: 'CSharp',
  opensource: 'OpenSource',
  db: 'Database',
  ruby: 'Ruby',
  devops: 'DevOps',
  security: 'Security',
  reactnative: 'ReactNative',
  linux: 'Linux',
};
